import React, { Component } from 'react';
import RadioButtonBonificacionRenovacionColumn from './RadioButtonBonificacionRenovacionColumn.jsx';

class RadioButtonBonificacionRenovacion extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { data } = this.props;

        let bonusNodes;
        let checked;
        let codigoPrecio = null;

        if (data != undefined && data != "") {

            const { GET_EMPRESA, id } = data;
            const selectedEmpresa = GET_EMPRESA.find(e => e.Id == id);
            let selectedBonificacion = parseInt(data.BonificacionRenovacion, 10);

            //if (selectedEmpresa != undefined)
            //    selectedBonificacion = selectedEmpresa.PorcentajeBonificacionRenovacion;

            data.EmpresaVisaPrecio = JSON.parse(JSON.stringify(this.props.data.GET_PRECIO_BY_CUENTA_VISA_TIPO));

            let bonus = JSON.parse(JSON.stringify(this.props.data.GET_BONIFICACION));
            let me = this;
            
            bonusNodes = bonus.map(function (row) {

                checked = row.Id == selectedBonificacion;

                return (
                    <RadioButtonBonificacionRenovacionColumn
                        Id={row.Id}
                        Descripcion={row.Descripcion}
                        PorcentajeBonificacion={row.PorcentajeBonificacion}
                        checked={checked}
                        changeRadio={me.props.changeRadio} />
                );
            })
        }

        if (this.props.data.EmpresaVisaPrecio.length > 0) {
            codigoPrecio = <div className="row">
                <div>
                    <label className="label-primary">Código de precio de la renovación</label>
                </div>
                <div>
                    <label className="label-secondary">{this.props.data.EmpresaVisaPrecio[0].Codigo}</label>
                </div>
            </div>;
        }

        return (
            <div className="row top-separator-xs left-separator-xs">
                <div className="col-xs-8">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary"> Bonificación de la renovación </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                {bonusNodes}
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {data.ERROR_EMPRESA["seleccionoBonificacionRenovacion"] == false ? <label className="error">Debe seleccionar al menos una bonificación de renovación.</label> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-4">
                    {codigoPrecio}
                </div>
            </div>
        );
    }
};

export default RadioButtonBonificacionRenovacion;